import { Button, Text } from "@mantine/core";

const BlockBtn = (props) => {
  return (
    <Button fullWidth variant={"gradient"} {...props} style={{ height: 44 }}>
      <Text size={16}>{props.children}</Text>
    </Button>
  );
};

export default BlockBtn;
